/// <reference types="./library.d.mts" />
import * as $data_source from "../../../../common/data/data_source.mjs";
import * as $page from "../../../../common/data/page.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $state from "../../../data/model/state.mjs";
import { CustomType as $CustomType } from "../../../gleam.mjs";

export class Library extends $CustomType {}

export function new$() {
  return new Library();
}

export function compute(_, _1, _2) {
  return new Library();
}
